/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M91.684 39.562c-.707-2.113-2.484-3.629-4.644-3.957l-21.93-3.29-9.872-20.952C54.262 9.289 52.254 8 50 8s-4.262 1.289-5.238 3.363l-9.727 20.879-22.07 3.36c-2.16.327-3.941 1.847-4.644 3.956-.723 2.168-.192 4.52 1.394 6.137l15.961 16.336-3.77 23.027c-.374 2.3.555 4.555 2.434 5.879a5.67 5.67 0 006.059.344L49.864 80.41l19.742 10.87a5.67 5.67 0 006.058-.343c1.88-1.324 2.81-3.578 2.434-5.879l-3.777-23.059L90.29 45.69c1.586-1.61 2.117-3.96 1.394-6.129zM70.036 57.808a6.058 6.058 0 00-1.629 5.195l3.735 22.824-19.388-10.672a5.69 5.69 0 00-5.511 0L27.856 85.831l3.738-22.828a6.035 6.035 0 00-1.629-5.191L13.863 41.535l22.07-3.36c1.906-.289 3.547-1.523 4.383-3.3L50 14.324l9.68 20.55c.84 1.778 2.476 3.012 4.382 3.301L86.003 41.5z"/>'
  }
})
